/**
 * @deprecated
 * @todo remove declaration with https://avivgroup.atlassian.net/browse/ASC-3772
 */
export const dataTestRoot = "aviv.CDP";
